module.exports = __webpack_public_path__ + "static/img/9.6f0e764.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/9.png
// module id = YUgH
// module chunks = 0